import { createAction } from "redux-actions";
import PaymentInit from "../../Networking/API/PaymentInit";
import PaymentInitTourist from "../../Networking/API/PaymentInitTourist";
import PaymentSubmit from "../../Networking/API/PaymentSubmit";
import PaymentSubmitTourist from "../../Networking/API/PaymentSubmitTourist";
import PaymentData from "../../Networking/API/PaymentData";
import PaymentDataTourist from "../../Networking/API/PaymentDataTourist";
import PaypalInit from "../../Networking/API/Paypalinit";
import PaypalLoginInit from "../../Networking/API/PaypalLoginInit";
import PaypalLoginComplete from "../../Networking/API/PaypalLoginComplete";
import PaypalGetPaymentData from "../../Networking/API/getPaymentDataPaypal";
import PaypalSubmit from "../../Networking/API/PaypalSubmit";
import GetPDF from "../../Networking/API/GetPDF";
import getMoneyAmounts from "../../Networking/API/getAmounts";
import GetEmail from "../../Networking/API/GetEmailReceipt";
import PaymentVoucher from "../../Networking/API/PaymentVoucher";
import i18next from "i18next";

const constants = {};

constants.PAYMENT_INIT_PENDING = "app/iotg/PAYMENT_INIT_PENDING";
constants.PAYMENT_INIT_SUCCESS = "app/iotg/PAYMENT_INIT_SUCCESS";
constants.PAYMENT_INIT_FAILURE = "app/iotg/PAYMENT_INIT_FAILURE";
constants.PAYMENT_SUBMIT_PENDING = "app/iotg/PAYMENT_SUBMIT_PENDING";
constants.PAYMENT_SUBMIT_SUCCESS = "app/iotg/PAYMENT_SUBMIT_SUCCESS";
constants.PAYMENT_SUBMIT_FAILURE = "app/iotg/PAYMENT_SUBMIT_FAILURE";
constants.GET_PAYMENT_DATA_PENDING = "app/iotg/GET_PAYMENT_DATA_PENDING";
constants.GET_PAYMENT_DATA_SUCCESS = "app/iotg/GET_PAYMENT_DATA_SUCCESS";
constants.GET_PAYMENT_DATA_FAILURE = "app/iotg/GET_PAYMENT_DATA_FAILURE";
constants.PAYPAL_INIT_PENDING = "app/iotg/PAYPAL_INIT_PENDING";
constants.PAYPAL_INIT_SUCCESS = "app/iotg/PAYPAL_INIT_SUCCESS";
constants.PAYPAL_INIT_FAILURE = "app/iotg/PAYPAL_INIT_FAILURE";
constants.PAYPAL_LOGIN_INIT_PENDING = "app/iotg/PAYPAL_LOGIN_INIT_PENDING";
constants.PAYPAL_LOGIN_INIT_SUCCESS = "app/iotg/PAYPAL_LOGIN_INIT_SUCCESS";
constants.PAYPAL_LOGIN_INIT_FAILURE = "app/iotg/PAYPAL_LOGIN_INIT_FAILURE";
constants.PAYPAL_LOGIN_COMPLETE_PENDING =
	"app/iotg/PAYPAL_LOGIN_COMPLETE_PENDING";
constants.PAYPAL_LOGIN_COMPLETE_SUCCESS =
	"app/iotg/PAYPAL_LOGIN_COMPLETE_SUCCESS";
constants.PAYPAL_LOGIN_COMPLETE_FAILURE =
	"app/iotg/PAYPAL_LOGIN_COMPLETE_FAILURE";
constants.PAYPAL_SUBMIT_PENDING = "app/iotg/PAYPAL_SUBMIT_PENDING";
constants.PAYPAL_SUBMIT_SUCCESS = "app/iotg/PAYPAL_SUBMIT_SUCCESS";
constants.PAYPAL_SUBMIT_FAILURE = "app/iotg/PAYPAL_SUBMIT_FAILURE";
constants.PAYPAL_GET_PAYMENT_DATA_PENDING =
	"app/iotg/PAYPAL_GET_PAYMENT_DATA_PENDING";
constants.PAYPAL_GET_PAYMENT_DATA_SUCCESS =
	"app/iotg/PAYPAL_GET_PAYMENT_DATA_SUCCESS";
constants.PAYPAL_GET_PAYMENT_DATA_FAILURE =
	"app/iotg/PAYPAL_GET_PAYMENT_DATA_FAILURE";
constants.PAYMENT_GET_PDF_PENDING = "app/iotg/PAYMENT_GET_PDF_PENDING";
constants.PAYMENT_GET_PDF_SUCCESS = "app/iotg/PAYMENT_GET_PDF_SUCCESS";
constants.PAYMENT_GET_PDF_FAILURE = "app/iotg/PAYMENT_GET_PDF_FAILURE";
constants.GET_AMOUNTS_PENDING = "app/iotg/GET_AMOUNTS_PENDING";
constants.GET_AMOUNTS_SUCCESS = "app/iotg/GET_AMOUNTS_SUCCESS";
constants.GET_AMOUNTS_FAILURE = "app/iotg/GET_AMOUNTS_FAILURE";
constants.PAYMENT_GET_EMAIL_PENDING = "app/iotg/PAYMENT_GET_EMAIL_PENDING";
constants.PAYMENT_GET_EMAIL_SUCCESS = "app/iotg/PAYMENT_GET_EMAIL_SUCCESS";
constants.PAYMENT_GET_EMAIL_FAILURE = "app/iotg/PAYMENT_GET_EMAIL_FAILURE";
constants.PAYMENT_VOUCHER_PENDING = "app/iotg/PAYMENT_VOUCHER_PENDING";
constants.PAYMENT_VOUCHER_SUCCESS = "app/iotg/PAYMENT_VOUCHER_SUCCESS";
constants.PAYMENT_VOUCHER_FAILURE = "app/iotg/PAYMENT_VOUCHER_FAILURE";

const paymentInitPending = createAction(constants.PAYMENT_INIT_PENDING);
const paymentInitSuccess = createAction(constants.PAYMENT_INIT_SUCCESS);
const paymentInitFailure = createAction(constants.PAYMENT_INIT_FAILURE);
const paymentSubmitPending = createAction(constants.PAYMENT_SUBMIT_PENDING);
const paymentSubmitSuccess = createAction(constants.PAYMENT_SUBMIT_SUCCESS);
const paymentSubmitFailure = createAction(constants.PAYMENT_SUBMIT_FAILURE);
const paymentGetDataPending = createAction(constants.GET_PAYMENT_DATA_PENDING);
const paymentGetDataSuccess = createAction(constants.GET_PAYMENT_DATA_SUCCESS);
const paymentGetDataFailure = createAction(constants.GET_PAYMENT_DATA_FAILURE);
const paypalInitPending = createAction(constants.PAYPAL_INIT_PENDING);
const paypalInitSuccess = createAction(constants.PAYPAL_INIT_SUCCESS);
const paypalInitFailure = createAction(constants.PAYPAL_INIT_FAILURE);
const paypalLoginInitPending = createAction(
	constants.PAYPAL_LOGIN_INIT_PENDING,
);
const paypalLoginInitSuccess = createAction(
	constants.PAYPAL_LOGIN_INIT_SUCCESS,
);
const paypalLoginInitFailure = createAction(
	constants.PAYPAL_LOGIN_INIT_FAILURE,
);
const paypalLoginCompletePending = createAction(
	constants.PAYPAL_LOGIN_COMPLETE_PENDING,
);
const paypalLoginCompleteSuccess = createAction(
	constants.PAYPAL_LOGIN_COMPLETE_SUCCESS,
);
const paypalLoginCompleteFailure = createAction(
	constants.PAYPAL_LOGIN_COMPLETE_FAILURE,
);
const paypalSubmitPending = createAction(constants.PAYPAL_SUBMIT_PENDING);
const paypalSubmitSuccess = createAction(constants.PAYPAL_SUBMIT_SUCCESS);
const paypalSubmitFailure = createAction(constants.PAYPAL_SUBMIT_FAILURE);
const paypalGetPaymentDataPending = createAction(
	constants.PAYPAL_GET_PAYMENT_DATA_PENDING,
);
const paypalGetPaymentDataSuccess = createAction(
	constants.PAYPAL_GET_PAYMENT_DATA_SUCCESS,
);
const paypalGetPaymentDataFailure = createAction(
	constants.PAYPAL_GET_PAYMENT_DATA_FAILURE,
);
const paymentGetPdfPending = createAction(constants.PAYMENT_GET_PDF_PENDING);
const paymentGetPdfSuccess = createAction(constants.PAYMENT_GET_PDF_SUCCESS);
const paymentGetPdfFailure = createAction(constants.PAYMENT_GET_PDF_FAILURE);
const getAmountsPending = createAction(constants.GET_AMOUNTS_PENDING);
const getAmountsSuccess = createAction(constants.GET_AMOUNTS_SUCCESS);
const getAmountsFailure = createAction(constants.GET_AMOUNTS_FAILURE);
const paymentGetEmailPending = createAction(
	constants.PAYMENT_GET_EMAIL_PENDING,
);
const paymentGetEmailSuccess = createAction(
	constants.PAYMENT_GET_EMAIL_SUCCESS,
);
const paymentGetEmailFailure = createAction(
	constants.PAYMENT_GET_EMAIL_FAILURE,
);
const paymentVoucherPending = createAction(constants.PAYMENT_VOUCHER_PENDING);
const paymentVoucherSuccess = createAction(constants.PAYMENT_VOUCHER_SUCCESS);
const paymentVoucherFailure = createAction(constants.PAYMENT_VOUCHER_FAILURE);

const paymentInitializer = () => async (dispatch, getState) => {
	try {
		dispatch(paymentInitPending());
		const isTourist = Boolean(
			getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
		);
		const response = isTourist
			? await PaymentInitTourist({})
			: await PaymentInit({});
		if (response && response.data) {
			dispatch(paymentInitSuccess(response.data));
		}
	} catch (e) {
		dispatch(paymentInitFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const paymentSubmit = (data) => async (dispatch, getState) => {
	try {
		dispatch(paymentSubmitPending());

		const state = getState();
		const isTourist = Boolean(
			state?.BalanceReducer?.payloadAfterLogIn?.isTourist,
		);
		const payloadAfterLogIn = state?.BalanceReducer?.payloadAfterLogIn;
		const paymentInitData = state?.PaymentReducer?.paymentInitData;
		const passesItem = state?.PackagesReducer?.passes?.passesItem || [];
		const selectedPass =
			passesItem.find(
				(passItem) => Number(passItem?.price) === Number(data?.amount),
			) || passesItem[0];

		// Backend expects `language` as EL/EN, based on current i18next language.
		const touristLanguage = i18next.language === "en" ? "EN" : "EL";

		const response = isTourist
			? await PaymentSubmitTourist({
					merchantRef: data?.merchantRef,
					secToken: data?.secToken,
					key: data?.key,
					amount: Number(data?.amount),
					email: data?.email,
					purchaseType: selectedPass?.purchaseType,
					token: state?.PackagesReducer?.passes?.token,
					uid: selectedPass?.uid,
					language: touristLanguage,
					passesName: selectedPass?.name,
				})
			: await PaymentSubmit(data);
		if (response && response.data) {
			dispatch(paymentSubmitSuccess(response.data));
		}
	} catch (e) {
		dispatch(paymentSubmitFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const getPaymentData = (data) => async (dispatch, getState) => {
	try {
		dispatch(paymentGetDataPending());
		const isTourist = Boolean(
			getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
		);
		const response = isTourist
			? await PaymentDataTourist({ merchantRef: data?.merchantRef })
			: await PaymentData(data);
		if (response && response.data) {
			const normalizedPayload = isTourist
				? {
						...response.data,
						success: Boolean(response.data?.successful),
						merchantRef: response.data?.merchantRef ?? data?.merchantRef,
						transactionDate:
							response.data?.transactionDate ?? response.data?.dateTime,
					}
				: response.data;
			dispatch(paymentGetDataSuccess(normalizedPayload));
		}
	} catch (e) {
		dispatch(paymentGetDataFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const getPaypalInit = () => async (dispatch, getState) => {
	try {
		const isTourist = Boolean(
			getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
		);
		if (isTourist) return;

		dispatch(paypalInitPending());
		const response = await PaypalInit({});
		if (response && response.data) {
			dispatch(paypalInitSuccess(response.data));
		}
	} catch (e) {
		dispatch(paypalInitFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const callLoginInit =
	(key, paypalSaveEnabled, flowId) => async (dispatch, getState) => {
		try {
			const isTourist = Boolean(
				getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
			);
			if (isTourist) return;

			dispatch(paypalLoginInitPending());
			const response = await PaypalLoginInit({
				key,
				paypalSaveEnabled,
				flowId,
			});
			if (response && response.data) {
				dispatch(paypalLoginInitSuccess(response.data));
			}
		} catch (e) {
			dispatch(paypalLoginInitFailure());
			dispatch({
				type: "alert/OPEN_FAILURE",
				payload: "generalError",
			});
		}
	};

const paypalComplete =
	(
		key,
		transactionToken,
		flowId,
		paymentNonce,
		paypalEmail,
		paypalFirstName,
		paypalLastName,
		paypalPayerId,
		paypalCountryCode,
	) =>
	async (dispatch, getState) => {
		try {
			const isTourist = Boolean(
				getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
			);
			if (isTourist) return;

			dispatch(paypalLoginCompletePending());
			const response = await PaypalLoginComplete({
				key,
				transactionToken,
				flowId,
				paymentNonce,
				paypalEmail,
				paypalFirstName,
				paypalLastName,
				paypalPayerId,
				paypalCountryCode,
			});
			if (response && response.data) {
				dispatch(paypalLoginCompleteSuccess(response.data));
			}
		} catch (e) {
			dispatch(paypalLoginCompleteFailure());
			dispatch({
				type: "alert/OPEN_FAILURE",
				payload: "generalError",
			});
		}
	};

const paypalSubmit =
	(
		key,
		transactionToken,
		flowId,
		nonce,
		useSavedAccount,
		amount,
		deviceData,
		vault,
		paypalEmail,
	) =>
	async (dispatch, getState) => {
		try {
			const isTourist = Boolean(
				getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
			);
			if (isTourist) return;

			dispatch(paypalSubmitPending());
			let data;
			if (vault !== null) {
				data = {
					deviceData: deviceData,
					key: key,
					flowId: flowId,
					useSavedAccount: useSavedAccount,
					amount: amount,
					vault: vault,
				};
			} else {
				data = {
					deviceData: deviceData,
					key: key,
					transactionToken: transactionToken,
					flowId: flowId,
					paymentNonce: nonce,
					useSavedAccount: useSavedAccount,
					amount: amount,
					vault: { paypalEmail: paypalEmail },
				};
			}
			const response = await PaypalSubmit(data);
			if (response && response.data) {
				dispatch(paypalSubmitSuccess(response.data));
			}
		} catch (e) {
			dispatch(paypalSubmitFailure());
			dispatch({
				type: "alert/OPEN_FAILURE",
				payload: "generalError",
			});
		}
	};

const getDataPaymentPaypal =
	(key, transactionToken) => async (dispatch, getState) => {
		try {
			const isTourist = Boolean(
				getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
			);
			if (isTourist) return;

			dispatch(paypalGetPaymentDataPending());
			const response = await PaypalGetPaymentData({ key, transactionToken });
			if (response && response.data) {
				dispatch(paypalGetPaymentDataSuccess(response.data));
			}
		} catch (e) {
			dispatch(paypalGetPaymentDataFailure());
			dispatch({
				type: "alert/OPEN_FAILURE",
				payload: "generalError",
			});
		}
	};

const getPDF = (dataAfterInit, initData) => async (dispatch) => {
	try {
		dispatch(paymentGetPdfPending());
		let data;
		if (dataAfterInit.type === "paypal") {
			data = {
				type: "paypal",
				transactionDate: dataAfterInit.datetime,
				email: dataAfterInit.email,
				paypalTransactionId: dataAfterInit.paypalTransactionId,
				key: initData,
				amount: dataAfterInit.amount,
				paypal: {
					paypalEmail: dataAfterInit.email,
					transactionToken: dataAfterInit.transactionToken,
				},
			};
		} else {
			data = {
				type: "card",
				notifyToken: dataAfterInit.notifyToken,
				merchantRef: dataAfterInit.merchantRef,
				secToken: dataAfterInit.secToken,
				key: dataAfterInit.key,
				transactionDate: dataAfterInit.transactionDate,
				amount: dataAfterInit.amount,
				authCode: dataAfterInit.authCode,
				card: {
					pan: dataAfterInit.card.pan,
					brand: dataAfterInit.card.brand,
				},
			};
		}
		const response = await GetPDF(data);
		if (response && response.data) {
			dispatch(paymentGetPdfSuccess(response.data));
		}
	} catch (e) {
		dispatch(paymentGetPdfFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const receiveEmail = (dataAfterInit, email, key) => async (dispatch) => {
	try {
		dispatch(paymentGetEmailPending());
		let data;
		if (dataAfterInit.type === "paypal") {
			data = {
				type: "paypal",
				transactionDate: dataAfterInit.datetime,
				key: key,
				paypalTransactionId: dataAfterInit.paypalTransactionId,
				email: email,
				amount: dataAfterInit.amount,
				paypal: {
					paypalEmail: dataAfterInit.email,
					transactionToken: dataAfterInit.transactionToken,
				},
			};
		} else {
			data = {
				type: "card",
				notifyToken: dataAfterInit.notifyToken,
				merchantRef: dataAfterInit.merchantRef,
				secToken: dataAfterInit.secToken,
				key: dataAfterInit.key,
				email: email,
				transactionDate: dataAfterInit.transactionDate,
				amount: dataAfterInit.amount,
				authCode: dataAfterInit.authCode,
				card: {
					pan: dataAfterInit.card.pan,
					brand: dataAfterInit.card.brand,
				},
			};
		}
		const response = await GetEmail(data);
		if (response) {
			dispatch(paymentGetEmailSuccess(response.data));
		}
	} catch (e) {
		dispatch(paymentGetEmailFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const getAmounts = () => async (dispatch, getState) => {
	try {
		const isTourist = Boolean(
			getState()?.BalanceReducer?.payloadAfterLogIn?.isTourist,
		);
		if (isTourist) return;

		dispatch(getAmountsPending());
		const response = await getMoneyAmounts();
		if (response && response.data) {
			dispatch(getAmountsSuccess(response.data));
		}
	} catch (e) {
		dispatch(getAmountsFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const getVoucherPayment = (val) => async (dispatch) => {
	try {
		dispatch(paymentVoucherPending());
		const response = await PaymentVoucher({ rechargeCode: val });
		if (response) {
			dispatch(paymentVoucherSuccess(response.data));
		}
	} catch (e) {
		dispatch(paymentVoucherFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const initialState = {
	loading: false,
	paymentInitData: {},
	paymentURL: "",
	paymentDataAfterPayment: {},
	paypalInitData: {},
	paypalLoginInitData: {},
	completePaypalData: {},
	paypalSubmitData: {},
	getPaymentPaypalData: {},
	pdf: "",
	amounts: {},
	voucherMsg: false,
	emailHasBeenSent: false,
	errorMessageHandler: false,
	errorMessageHandlerVoucher: false,
	errorMessageHandlerCardInit: false,
	errorMessageHandlerPaypalInit: false,
	errorMessageHandlerAmounts: false,
	errorGetPaymentData: false,
	errorSubmitPaypal: false,
	errorPaypalGetData: false,
	errorEmailSent: false,
};

export const paymentActions = {
	paymentInitializer,
	paymentSubmit,
	getPaymentData,
	getPaypalInit,
	callLoginInit,
	paypalComplete,
	paypalSubmit,
	getDataPaymentPaypal,
	getPDF,
	getAmounts,
	receiveEmail,
	getVoucherPayment,
};

const PaymentReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case constants.PAYMENT_INIT_PENDING:
			return {
				...state,
				loading: true,
				paymentInitData: {},
				errorMessageHandlerCardInit: false,
			};
		case constants.PAYMENT_INIT_FAILURE:
			return { ...state, loading: false, errorMessageHandlerCardInit: true };
		case constants.PAYMENT_INIT_SUCCESS:
			return {
				...state,
				loading: false,
				paymentInitData: payload,
				errorMessageHandlerCardInit: false,
			};
		case constants.PAYMENT_SUBMIT_PENDING:
			return { ...state, loading: true };
		case constants.PAYMENT_SUBMIT_FAILURE:
			return { ...state, loading: false };
		case constants.PAYMENT_SUBMIT_SUCCESS:
			return { ...state, loading: false, paymentURL: payload };
		case constants.GET_PAYMENT_DATA_PENDING:
			return { ...state, loading: true, errorGetPaymentData: false };
		case constants.GET_PAYMENT_DATA_FAILURE:
			return { ...state, loading: false, errorGetPaymentData: true };
		case constants.GET_PAYMENT_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				paymentDataAfterPayment: payload,
				errorGetPaymentData: false,
			};
		case constants.PAYPAL_INIT_PENDING:
			return { ...state, loading: true, errorMessageHandlerPaypalInit: false };
		case constants.PAYPAL_INIT_FAILURE:
			return { ...state, loading: false, errorMessageHandlerPaypalInit: true };
		case constants.PAYPAL_INIT_SUCCESS:
			return {
				...state,
				loading: false,
				paypalInitData: payload,
				errorMessageHandlerPaypalInit: false,
			};
		case constants.PAYPAL_LOGIN_INIT_PENDING:
			return { ...state, loading: true, errorMessageHandler: false };
		case constants.PAYPAL_LOGIN_INIT_FAILURE:
			return { ...state, loading: false, errorMessageHandler: true };
		case constants.PAYPAL_LOGIN_INIT_SUCCESS:
			return {
				...state,
				loading: false,
				paypalLoginInitData: payload,
				errorMessageHandler: false,
			};
		case constants.PAYPAL_LOGIN_COMPLETE_PENDING:
			return { ...state, loading: true };
		case constants.PAYPAL_LOGIN_COMPLETE_FAILURE:
			return { ...state, loading: false };
		case constants.PAYPAL_LOGIN_COMPLETE_SUCCESS:
			return { ...state, loading: false, completePaypalData: payload };
		case constants.PAYPAL_SUBMIT_PENDING:
			return { ...state, loading: true, errorSubmitPaypal: false };
		case constants.PAYPAL_SUBMIT_FAILURE:
			return { ...state, loading: false, errorSubmitPaypal: true };
		case constants.PAYPAL_SUBMIT_SUCCESS:
			return {
				...state,
				loading: false,
				paypalSubmitData: payload,
				errorSubmitPaypal: false,
			};
		case constants.PAYPAL_GET_PAYMENT_DATA_PENDING:
			return { ...state, loading: true, errorPaypalGetData: false };
		case constants.PAYPAL_GET_PAYMENT_DATA_FAILURE:
			return { ...state, loading: false, errorPaypalGetData: true };
		case constants.PAYPAL_GET_PAYMENT_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				getPaymentPaypalData: payload,
				errorPaypalGetData: false,
			};
		case constants.PAYMENT_GET_PDF_PENDING:
			return { ...state, loading: true };
		case constants.PAYMENT_GET_PDF_FAILURE:
			return { ...state, loading: false };
		case constants.PAYMENT_GET_PDF_SUCCESS:
			return { ...state, loading: false, pdf: payload };
		case constants.GET_AMOUNTS_PENDING:
			return { ...state, loading: true, errorMessageHandlerAmounts: false };
		case constants.GET_AMOUNTS_FAILURE:
			return { ...state, loading: false, errorMessageHandlerAmounts: true };
		case constants.GET_AMOUNTS_SUCCESS:
			return {
				...state,
				loading: false,
				errorMessageHandlerAmounts: false,
				amounts: payload,
			};
		case constants.PAYMENT_VOUCHER_PENDING:
			return { ...state, loading: true, errorMessageHandlerVoucher: false };
		case constants.PAYMENT_VOUCHER_FAILURE:
			return { ...state, loading: false, errorMessageHandlerVoucher: true };
		case constants.PAYMENT_VOUCHER_SUCCESS:
			return {
				...state,
				loading: false,
				voucherMsg: true,
				errorMessageHandlerVoucher: false,
			};
		case constants.PAYMENT_GET_EMAIL_PENDING:
			return {
				...state,
				loading: true,
				emailHasBeenSent: false,
				errorEmailSent: false,
			};
		case constants.PAYMENT_GET_EMAIL_FAILURE:
			return {
				...state,
				loading: false,
				emailHasBeenSent: false,
				errorEmailSent: true,
			};
		case constants.PAYMENT_GET_EMAIL_SUCCESS:
			return {
				...state,
				loading: false,
				emailHasBeenSent: true,
				errorEmailSent: false,
			};
		default:
			return state;
	}
};

export default PaymentReducer;
